import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Shield, Star, CheckCircle } from 'lucide-react';

const CTASection = () => {
  return (
    <section id="contact" className="py-20 lg:py-28 bg-primary relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 hero-pattern opacity-50" />
      
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 rounded-full bg-gold/10 blur-3xl" />
      <div className="absolute bottom-0 left-0 w-80 h-80 rounded-full bg-accent/10 blur-3xl" />

      <div className="section-container relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/10 border border-gold/30 mb-8">
            <Shield className="w-4 h-4 text-gold" />
            <span className="text-sm font-medium text-gold">
              Check Your Eligibility
            </span>
          </div>

          {/* Headline */}
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-primary-foreground mb-6">
            Ready to Reclaim Your Money?
          </h2>

          {/* Subheadline */}
          <p className="text-lg sm:text-xl text-primary-foreground/80 leading-relaxed mb-10 max-w-2xl mx-auto">
            Join thousands of satisfied clients who have recovered hidden commission 
            on their car finance. Start your claim check today.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button variant="gold" size="xl" className="animate-pulse-glow" asChild>
              <a href="https://signup.bluelionclaims.co.uk/" target="_blank" rel="noopener noreferrer">
                Find Your Agreements
                <ArrowRight className="w-5 h-5" />
              </a>
            </Button>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap gap-6 justify-center">
            <div className="flex items-center gap-2 text-primary-foreground/80">
              <CheckCircle className="w-5 h-5 text-success" />
              <span className="text-sm font-medium">No Win, No Fee</span>
            </div>
            <div className="flex items-center gap-2 text-primary-foreground/80">
              <Shield className="w-5 h-5 text-accent" />
              <span className="text-sm font-medium">SRA Regulated</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export { CTASection };
